import { reflect } from '@effector/reflect';
import { AppShell } from '@mantine/core';
import { createBlockGameModal } from 'features/block-game';
import { createUnblockGameModal } from 'features/unblock-game';
import { createGameRegistry } from 'entities/game';
import { translated } from 'shared/lib';
import { MultiSelect } from 'shared/ui';
import { gamesPageModel } from '../../model';
import cls from './games-page.module.scss';

const GameRegistry = createGameRegistry(gamesPageModel.gameRegistryModel);

const BlockGameModal = createBlockGameModal(gamesPageModel.blockGameModel);

const UnblockGameModal = createUnblockGameModal(gamesPageModel.unblockGameModel);

const GamesField = reflect({
	view: MultiSelect,
	bind: {
		data: gamesPageModel.getGamesQuery.$data.map((games) =>
			games ? games.map((game) => ({ value: `${game.id}`, label: game.title })) : [],
		),
		value: gamesPageModel.gameRegistryModel.filters.gameIds.$value.map((value) =>
			value.map(String),
		),
		onChange: (v) => gamesPageModel.gameRegistryModel.filters.gameIds.setValue(v.map(Number)),
		label: translated('games-page.games'),
		placeholder: translated('games-page.all'),
	},
});

export const GamesPage = () => (
	<>
		<AppShell.Main className={cls.gamesPage}>
			<GameRegistry
				className={cls.gamesPageGameRegistry}
				tableTdActionSlot={(game) => (
					<div className={cls.gamesPageActions}>
						{game.isLocked ? (
							<UnblockGameModal.ActionIcon modalData={game} />
						) : (
							<BlockGameModal.ActionIcon modalData={game} />
						)}
					</div>
				)}
				filterSlot={<GamesField />}
			/>
		</AppShell.Main>
		<BlockGameModal />
		<UnblockGameModal />
	</>
);
